import { useHead } from '@unhead/vue'

export const VueHeadOptionsMixin = {
  created() {
    const headOption = this.$options.head

    if (!headOption) return

    const source = typeof headOption === 'function' ? () => headOption.call(this) : headOption
    useHead(source)
  },
}
